module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('list-view', {
    staticClass: "combination-component-type-selector"
  }, _vm._l((_vm.combinationTypes), function(combinationType) {
    return _c('div', {
      staticClass: "combination-type",
      attrs: {
        "selected": combinationType == _vm.value
      },
      on: {
        "click": function($event) {
          _vm.combinationTypeSelected(combinationType)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getComponentCombinationName(combinationType)) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ceb61ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combination-component-type-selector.vue
// module id = 194
// module chunks = 5